import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { domainName } from "../../../utility/index"
import { downLoadTemplateFile, exportTerminalFile } from '../../../api/config/modules/TerminalFile'
export default {
    name: "DriverFingerprintFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                driverName: '',
                fingerNum: '',
            },
            typeList: [],
            numList: [],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "driverNum",
                label: this.$t('common.driverNum'),
                align: "center",
            },
            {
                prop: "driverName",
                label: this.$t('common.driverName'),
                align: "center",
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",

            },
            {
                prop: "fingerNum",
                label: this.$t('DriverManagement.fingerNum'),
                align: "center",
            },
            {
                prop: "remarks",
                label: this.$t('common.remark'),
                align: "center",

            }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "DRIVERFINGERPRINTFILE_DETAIL",
                        method: (index, row) => {
                            this.driverNum = row.driverNum
                            this.dialogOperateFormVisible = true
                            this.getOperateList()
                        }
                    }
                ]
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                terminalId: [{
                    required: true,
                    message: this.$t('common.form.terminalId'),
                    trigger: 'blur'
                }],
                typeId: [{
                    required: true,
                    message: this.$t('common.form.terminalType'),
                    trigger: 'change'
                }],
                deliveryTime: [{
                    required: true,
                    message: this.$t('TerminalFile.form.deliveryTime'),
                    trigger: 'change'
                }],
            },
            form: {
                driverNum: '',
                terminalType: '',
                terminalNum: '',
            },

            selected: [],
            id: '',
            name: '',
            dialogOperateFormVisible: false,
            authorizeList: [],
            authorizeHeight: '350px',
            authorizeColumns: [
                {
                    prop: "fingerGroup",
                    label: this.$t('DriverManagement.fingerGroup'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "name",
                    label: this.$t('common.driverName'),
                    align: "center",
                },
                {
                    prop: "authorizeCount",
                    label: this.$t('DriverManagement.authorizes'),
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: this.$t('common.createTime'),
                    align: "center",
                },
            ],
            authorizeOperates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogOperateFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            AuthorizeCurrentPage: 1,
            AuthorizePageSize: 10,
            AuthorizeTotal: 1,
        }
    },
    created() {
        this.getTerminalType()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getDriverFinger()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getDriverFinger()
        },
        getDriverFinger() {
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                fingerNum: this.formInline.fingerNum,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFingerprintFile/GET_DRIVERFINGERPRINT', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getDriverFinger()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                fingerNum: '',
            }
            this.getDriverFinger()
        },
        getTerminal() {
            this.getCar()
        },
        getTerminalType() {
            this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.typeList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        getCar() {
            let param = {
                orgId: sessionStorage.getItem("roleData"),
                typeId: this.form.terminalType,
                pageSize: 10000,
                pageNum: 1,
            };
            this.$store.dispatch("TerminalFile/GET_SELECTALLTERMINAL", param).then((res) => {
                if (res.data.code == 200) {
                    this.numList = res.data.data.list;
                }

            })
                .catch((err) => {
                });
        },
        addTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('DriverManagement.btn.addDriverFinger')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.driverNum = this.selected[0].driverNum
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        driverNum: this.form.driverNum,
                        terminalType: this.form.terminalType,
                        terminalNum: this.form.terminalNum,
                    }
                    this.$store.dispatch('DriverFingerprintFile/GET_INSERTDRIVERFINGER', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('DriverManagement.form.addDriverFingerSuccess'))
                            this.dialogFormVisible = false;
                            this.getDriverFinger();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                driverNum: '',
                terminalType: '',
                terminalNum: '',
            }
        },
        closeDia() {
            this.form = {
                driverNum: '',
                terminalType: '',
                terminalNum: '',
            }
            this.dialogFormVisible = false;
        },
        deleteTerminal() {
            this.$confirm(this.$t('common.btn.confirmClear'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    driverNum: this.selected[0].driverNum
                }
                this.$store.dispatch('DriverFingerprintFile/GET_DELETEBYDRIVERNUM', param).then(response => {
                    if (response.data.code == 200) {
                        this.getDriverFinger()
                        this.$message.success(this.$t('common.btn.clearSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        downTerminal() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let companyId = sessionStorage.getItem("companyId")

                    let url = `https://${domainName}/v1/getExportExcel/exportFingerNum?orgId=${this.id}&companyId=${companyId}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&fingerNum=${this.formInline.fingerNum}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportFingerNum?orgId=${this.id}&companyId=${companyId}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&fingerNum=${this.formInline.fingerNum}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getDriverFinger();
        },
        getOperateList() {
            let param = {
                orgId: this.id,
                driverNum: this.driverNum,
                pageNum: this.AuthorizeCurrentPage,
                pageSize: this.AuthorizePageSize,
            }
            this.$store.dispatch('DriverFingerprintFile/GET_SELECTFINGERLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.authorizeList = res.data.data.list
                        this.$refs.AuthorizePage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        handleAuthorizeChange(val) {
            this.select = val
        },
        changeAuthorizeSize(item) {
            this.AuthorizePageSize = item.pageSize
            this.AuthorizeCurrentPage = item.pageNum
            this.getOperateList();
        },
        queryDetails(index, row) {
            console.log(row)
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = {
                        driverNum: row.driverNum,
                        fingerGroup: row.fingerGroup
                    }
                    this.$store.dispatch('DriverFingerprintFile/GET_DELETEDRIVERFINGER', param).then(response => {
                        if (response.data.code == 200) {
                            this.getOperateList()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}